const businessData = [
  { label: '金融', percentage: 70, color: '#3F6844' },
  { label: '官公庁・自治体', percentage: 20, color: '#90C784' },
  { label: 'その他', percentage: 10, color: '#E6F4DC' },
];

const ageEngineerData = [
  { label: '20代（21名）', percentage: 71, color: '#3F6844' },
  { label: '30代（7名）', percentage: 25, color: '#75AC68' },
  { label: '40代（1名）', percentage: 3, color: '#E6F4DC' },
];

const ageAllData = [
  { label: '20代（22名）', percentage: 64, color: '#3F6844' },
  { label: '30代（8名）', percentage: 24, color: '#75AC68' },
  { label: '40代（4名）', percentage: 12, color: '#CBE9BD' },
];

const phaseData = [
  { label: '試験(結合・総合)', percentage: 87, color: '#3F6844' },
  { label: '製造', percentage: 82.6, color: '#5A8A55' },
  { label: '詳細設計', percentage: 73.9, color: '#75AC68' },
  { label: '基本設計', percentage: 69.6, color: '#75AC68' },
  { label: '保守・運用', percentage: 60.9, color: '#90C784' },
  { label: '要件定義', percentage: 52.2, color: '#AEDD9F' },
  { label: 'PMO', percentage: 4.3, color: '#E6F4DC' },
  { label: 'AIを使った製造', percentage: 4.3, color: '#E6F4DC' },
  { label: 'サーバー環境構築', percentage: 4.3, color: '#E6F4DC' }
];

const languageData = [
  { label: 'Java', percentage: 87, color: '#3F6844' },
  { label: 'JavaScript', percentage: 82.6, color: '#5A8A55' },
  { label: 'PL/SQL', percentage: 73.9, color: '#75AC68' },
  { label: 'VBA', percentage: 65.2, color: '#90C784' },
  { label: 'PHP', percentage: 26.1, color: '#AEDD9F' },
  { label: 'Python', percentage: 17.4, color: '#CBE9BD' },
  { label: 'C#', percentage: 17.4, color: '#CBE9BD' },
  { label: 'C++', percentage: 17.4, color: '#CBE9BD' },
  { label: 'React', percentage: 4.3, color: '#E6F4DC' },
  { label: 'C', percentage: 4.3, color: '#E6F4DC' },
  { label: 'COBOL', percentage: 4.3, color: '#E6F4DC' }
];

const BarChart = ({ data, title }: { data: typeof businessData; title: string }) => (
  <div className="flex-1">
    <h3 className="text-base font-bold text-[#89B56B] mb-6 text-center">{title}</h3>
    <div className="space-y-4">
      {data.map((item, index) => (
        <div key={index}>
          <div className="flex items-center justify-between mb-1.5">
            <span className="text-[13px] text-gray-700 font-medium">{item.label}</span>
            <span className="text-[12px] text-gray-500 font-['Inter']">{item.percentage}%</span>
          </div>
          <div className="w-full h-2.5 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-700 ease-out"
              style={{ width: `${item.percentage}%`, backgroundColor: item.color }}
            />
          </div>
        </div>
      ))}
    </div>
  </div>
);

const recordData = [
  { system: '金融機関向け', detail: '与信管理システム', tech: 'Java、DB2、vue.js、Spring' },
  { system: '金融機関向け', detail: '信用リスク計算システム', tech: 'PL/SQL、Access、Oracle' },
  { system: '金融機関向け', detail: '海外送金システム', tech: 'Java、Oracle、Spring、Mybatis' },
  { system: '製造業向け', detail: 'MES（製造実行システム）', tech: 'JavaScript、PostgreSQL、TALON' },
  { system: '某省庁', detail: '総合管理システム', tech: 'Java、JSP、C、C++、C#、Oracle' },
  { system: '自治体向け', detail: '教育クラウド', tech: 'Java、Python、PostgreSQL' },
  { system: '某自動車企業', detail: 'グローバル市場品質システム', tech: 'Java、Oracle' },
  { system: '自治体向け', detail: '勤怠管理システム', tech: 'Java、JSP、PostgreSQL' },
];

const RecordTable = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-gray-50 rounded-2xl p-8 mb-8">
          <div className="flex flex-col md:flex-row gap-4">
            <BarChart data={businessData} title="業務内容" />
            <BarChart data={ageEngineerData} title={"年代比率\n(エンジニアのみ（29名）)"} />
            <BarChart data={ageAllData} title="年代比率(全社（34名）)" />
          </div>
        </div>

        <div className="bg-gray-50 rounded-2xl p-8 mb-12">
          <div className="flex flex-col md:flex-row gap-12">
            <BarChart data={languageData} title="エンジニア" />
            <BarChart data={phaseData} title="対応可能フェーズ" />
          </div>
        </div>

        {/* 実績テーブル */}
        <div className="bg-white rounded-2xl overflow-hidden">
          <div className="flex border-b border-gray-100 bg-white">
            <div className="flex-1 px-6 py-4">
              <span className="text-[13px] font-bold text-[#89B56B]">システム内容</span>
            </div>
            <div className="flex-1 px-6 py-4">
              <span className="text-[13px] font-bold text-[#89B56B]">言語、DB等</span>
            </div>
          </div>

          {recordData.map((item, index) => (
            <div
              key={index}
              className={`flex group hover:bg-gray-50 transition-colors ${
                index !== recordData.length - 1 ? 'border-b border-gray-100' : ''
              }`}
            >
              <div className="flex-1 px-6 py-5">
                <p className="text-[13px] text-gray-700 leading-relaxed font-medium">{item.system}</p>
                <p className="text-[13px] text-gray-500 leading-relaxed">{item.detail}</p>
              </div>
              <div className="flex-1 px-6 py-5 flex items-center">
                <p className="text-[13px] text-gray-700 leading-relaxed">{item.tech}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default RecordTable;
